import api from './api';

export const searchService = {
  searchProfiles: async (filters) => {
    const response = await api.post('/search', filters);
    return response.data;
  },

  exportResults: async (filters) => {
    const response = await api.post('/search/export', filters, {
      responseType: 'blob'
    });
    return response.data;
  }
};
